<template>
  <b-dropdown v-bind="$attrs" v-on="$listeners">
    <template #trigger="data">
      <slot name="trigger" v-bind="data"/>
    </template>
    <b-dropdown-item
      v-for="item in dropdownItems"
      :key="item.id"
      :disabled="item.disabled"
      @click="item.action">
      {{ item.libelle }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'qd-dropdown',
  props: {
    dropdownItems: {
      type: Array,
      required: true,
    },
  },
};
</script>
